import React from 'react';
import Swal from 'sweetalert2'

export default function Button(){

    function openPopup() {
        let timerInterval;
        Swal.fire({
            title: "Newsletter ist in Arbeit!",
            html: "Dieses Popup schließt sich in 5 Sekunden.",
            timer: 4000,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading();
            },
            willClose: () => {
                clearInterval(timerInterval);
            }
        }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
            }
        });
    }

    return(
        <div className='flex rounded-xl text-center border border-gray-400 bg-gray-700 hover:bg-gray-600 duration-300'>
            <p onClick={(() => {
                openPopup()
            })} className='decoration-0 cursor-pointer text-gray-200 pl-4 select-none pr-4 pt-2 pb-2'>
                Newsletter abonnieren
            </p>
        </div>
    )
}